<template>
    <b-overlay
        :show="status.isWaiting || invoiceStatus.isWaiting"
        variant="light"
        spinner-variant="primary"
    >
        <div class="bg-white rounded">
            <b-row class="justify-content-lg-center" no-gutters>
                <b-col :lg=9>
                    <b-table id="tasksTable" class="mb-1" responsive outlined borderless striped hover show-empty :empty-text="$t('app_table_empty_text')" :items="filterItems()" :fields="fields" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:head(selected)>
                            <b-form-checkbox size="lg" v-model="itemsChecked" @change="checkAll" />
                        </template>
                        <template v-slot:head(customer)>
                            {{ $t('task_label_customer') }}
                        </template>
                        <template v-slot:head(washstation)>
                            {{ $t('task_label_wash_station') }}
                        </template>
                        <template v-slot:head(startTime)>
                            {{ $t('task_label_start_time') }}
                        </template>
                        <template v-slot:head(endTime)>
                            {{ $t('task_label_end_time') }}
                        </template>
                        <template v-slot:head(worker)>
                            {{ $t('task_label_worker') }}
                        </template>
                        <template v-slot:head(description)>
                            {{ $t('task_label_description') }}
                        </template>
                        <template v-slot:head(invoice)>
                            {{ $t('task_label_invoice') }}
                        </template>
                        <template v-slot:head(actions)>
                            {{ $t('task_label_actions') }}
                        </template>
                        <template v-slot:cell(selected)="{ item }">
                            <b-form-checkbox size="lg" :value="item" v-model="selectedItems" @change="itemCheck" />
                        </template>
                        <template v-slot:cell(startTime)="{ item }">
                            {{ $moment(item.startTime).format(dateFormat) }}
                        </template>
                        <template v-slot:cell(endTime)="{ item }">
                            {{ $moment(item.endTime).format(dateFormat) }}
                        </template>
                        <!--
                        <template v-slot:cell(customer)="{ item }">
                            {{ item.customer.name }}
                        </template>
                        -->
                        <template v-slot:cell(washstation)="{ item }">
                            {{ item.washstation.name }}
                        </template>
                        <!--
                        <template v-slot:cell(worker)="{ item }">
                            {{ item.worker.firstname }} {{ item.worker.lastname }}
                        </template>
                        -->
                        <template v-slot:cell(description)="{ item }">
                            {{ item.description ? trimText(item.description) : "-" }}
                        </template>
                        <template v-slot:cell(invoice)="{ item }">
                            {{ item.invoice && item.invoiceSentAt ? $moment(item.invoiceSentAt).format(dateFormat) : "-" }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-button @click="showTaskModal(item)" variant="info" size="sm">{{ $t('task_button_view') }}</b-button>
                        </template>
                    </b-table>
                </b-col>
                <b-col :lg=3>
                    <b-card no-body class="p-0 mb-2" v-if="selectedItems.length">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-b-toggle.tab2 variant="light">
                                {{ $t('task_selected_items') }}: <b-badge pill variant="primary">{{ selectedItems.length }}</b-badge>
                            </b-button>
                        </b-card-header>
                        <b-collapse id="tab2" role="tabpanel">
                            <b-card-body class="p-2 text-center">
                                <b-button variant="secondary" @click="unselectAll()">{{ $t('task_button_remove_selection') }}</b-button>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="p-0">
                        <b-card-header header-tag="header" class="p-0" role="tab">
                            <b-button block v-b-toggle.tab1 variant="light">{{ $t('app_table_header_filters') }}</b-button>
                        </b-card-header>
                        <b-collapse id="tab1" visible role="tabpanel">
                            <b-card-body class="p-3">
                                <b-form-group label-size="sm" :label="$t('task_label_filter_search')" label-for="filterSearch" label-class="mb-0">
                                    <b-form-input v-model="filterSearch" id="filterSearch" :placeholder="$t('task_label_filter_search_placeholder')" size="sm" />
                                </b-form-group>
                                <b-form-group label-size="sm" :label="$t('task_label_filter_wash_station')" label-for="filterWashStation" label-class="mb-0">
                                    <v-select
                                        :options="washStationFilterOptions(washStations)"
                                        :reduce="washStation => washStation.val"
                                        label="name"
                                        v-model="filterWashStation"
                                        :clearable="false"
                                    >
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!filterWashStation"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <div slot="no-options">{{ $t('app_vselect_no_options_found') }}</div>
                                    </v-select>
                                </b-form-group>
                                <b-form-group label-size="sm" :label="$t('task_label_filter_worker')" label-for="filterWorker" label-class="mb-0">
                                    <v-select
                                        :options="workerFilterOptions(filterWorkers(workers))"
                                        :reduce="worker => worker.val"
                                        label="label"
                                        v-model="filterWorker"
                                        :clearable="false"
                                    >
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!filterWorker"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <div slot="no-options">{{ $t('app_vselect_no_options_found') }}</div>
                                    </v-select>
                                </b-form-group>
                                <b-form-group label-size="sm" :label="$t('task_label_filter_customer')" label-for="filterCustomer" label-class="mb-0">
                                    <v-select
                                        :options="customerFilterOptions(customers)"
                                        :reduce="worker => worker.val"
                                        label="name"
                                        v-model="filterCustomer"
                                        :clearable="false"
                                    >
                                        <template #search="{attributes, events}">
                                            <input
                                                class="vs__search"
                                                :required="!filterCustomer"
                                                v-bind="attributes"
                                                v-on="events"
                                            />
                                        </template>
                                        <div slot="no-options">{{ $t('app_vselect_no_options_found') }}</div>
                                    </v-select>
                                </b-form-group>
                                <b-form-group v-if="checkRole(user, 'ROLE_ADMIN')" label-size="sm" :label="$t('task_label_filter_only_uninvoiced')" label-for="filterOnlyUninvoiced" label-class="mb-0">
                                    <b-form-checkbox v-model="filterOnlyUninvoiced" id="filterOnlyUninvoiced" switch />
                                </b-form-group>
                                <b-form-group>
                                    <b-button @click="resetFilters" size="sm">{{ $t('app_table_button_filter_reset') }}</b-button>
                                </b-form-group>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="justify-content-lg-center pl-2 pr-2">
                <b-col>
                    <label>
                        <small><b>{{ $t('app_table_label_per_page') }}</b></small>
                        <b-form-select size="sm" v-model="perPage" :options="perPageOptions" />
                    </label>
                </b-col>
                <b-col class="d-flex">
                    <b-pagination class="my-auto ml-auto" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="tasksTable" /> 
                </b-col>
            </b-row>
        </div>
		<b-row class="justify-content-lg-center">
			<b-col>
                <hr />
                <b-button 
                    v-if="checkRole(user, 'ROLE_ADMIN')"
                    :disabled="selectedItems.length ? false : true" 
                    variant="primary" 
                    @click="showInvoiceModal()"
                >{{ $t('invoice_button_create') }}</b-button>
			</b-col>
		</b-row>
        
		<b-modal 
            ref="invoiceModal" 
            size="lg" 
            :title="$t('invoice_invoice_modal_title')" 
            ok-only
            :ok-title="$t('invoice_button_create_invoice')"
            @ok="createInvoice"
        >
            <b-alert show variant="warning" v-if="warnInvoiceCustomer()">
                {{ $t('invoice_invoice_modal_warning_customer') }}
            </b-alert>
            <b-alert show variant="info" v-if="warnInvoiceFilled()">
                {{ $t('invoice_invoice_modal_warning_filled') }}
            </b-alert>
            <b-list-group class="overflow-auto selected_items_scroll_list">
                <b-list-group-item 
                    v-for="(item, index) in selectedItems" 
                    :key="item.id"
                    class="d-flex justify-content-between align-items-center"
                    :variant="invoiceModalListItemVariant(item)"
                >
                    {{ $moment(item.startTime).format(dateFormat) }} - 
                    {{ item.worker.firstname }} {{ item.worker.lastname }} - 
                    {{ item.customer.name }} - 
                    {{ item.washstation.name }}
                    <b-button variant="danger" @click="unselectItem(index)"><b-icon icon="x" scale="1.25" /></b-button>
                </b-list-group-item>
            </b-list-group>
		</b-modal>
        
		<b-modal 
            ref="showTaskModal" 
            size="lg" 
            :title="$t('task_title_show')" 
            hide-footer
        >
            <task-show 
                :inModal="true"
                :task="activeTask"
                :invoice="invoice"
                :getInvoice="getInvoiceCall"
                :customers="customers"
                :products="products"
                :dateFormat="dateFormat"
                :translateUnit="translateUnit"
                :findById="findById"
                :calcDuration="calcDuration"
                :checkTaskCustomer="checkTaskCustomer"
            />
		</b-modal>
    </b-overlay>
</template>

<script>
import TaskShow from '../task/TaskShow'

export default {
    name: 'TaskIndex',
	components: {
		TaskShow,
	},
    props: [
        'user',
        'checkRole',
        'tasks',
        'status',
        'customers',
        'products',
        'washStations',
        'workers',
		'filterWorkers',
        'invoice',
		'invoiceStatus',
        'getInvoiceCall',
        'createInvoiceCall',
        'taskConfirmCall',
        'dateFormat',
        'findById',
        'checkTaskCustomer',
        'translateUnit',
        'calcDuration',
        'getTasksConfirmed'
    ],
    data() {
        return {
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 25,
            currentPage: 1,
            itemsChecked: false,
            selectedItems: [],
            fields: this.checkRole(this.user, 'ROLE_ADMIN') ? [
                { key: 'selected', sortable: false },
                { key: 'startTime', sortable: true },
                //{ key: 'endTime', sortable: true },
                {
                    key: 'worker',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return `${item.worker.firstname} ${item.worker.lastname}`
                    },
                    sortByFormatted: true,
                },
                {
                    key: 'customer',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return item.customer.name
                    },
                    sortByFormatted: true,
                },
                { key: 'washstation', sortable: true },
                { key: 'invoice', sortable: true },
                //{ key: 'description', sortable: true },
                { key: 'actions', sortable: false },
            ] : [
                { key: 'startTime', sortable: true },
                {
                    key: 'worker',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return `${item.worker.firstname} ${item.worker.lastname}`
                    },
                    sortByFormatted: true,
                },
                {
                    key: 'customer',
                    sortable: true,
                    formatter: (value, key, item) => {
                        return item.customer.name
                    },
                    sortByFormatted: true,
                },
                { key: 'washstation', sortable: true },
                { key: 'actions', sortable: false },
            ],
            filterSearch: '',
            filterWashStation: 'all',
            filterWorker: 'all',
            filterCustomer: 'all',
            filterOnlyUninvoiced: true,
            activeTask: null,
        }
    },
    computed: {
        rows() {
            return this.tasks ? this.tasks.length : 0;
        }
    },
    methods: {
        trimText(string) {
            var maxLength = 50;
            if (string.length > maxLength) {
                var trimmedString = string.substring(0, maxLength);
                return trimmedString + '...';
            } else {
                return string;
            }
        },
        itemCheck(checked) {
            if(!checked) {
                this.itemsChecked = false;
            }
        },
        checkAll(checked) {
            if (checked) {
                let items = this.filterItems();
                items.forEach(item => {
                    if (!this.selectedItems.find(selectedItem => selectedItem.id == item.id)) {
                        this.selectedItems.push(item);
                    }
                });
            } else {
                let items = this.filterItems();
                items.forEach(item => {
                    let index = this.selectedItems.findIndex(selectedItem => selectedItem.id == item.id);
                    if (index != -1) {
                        this.selectedItems.splice(index, 1);
                    }
                });
            }
        },
        unselectItem(index) {
            this.itemsChecked = false;
            this.selectedItems.splice(index, 1);
            if (!this.selectedItems.length) {
                this.$refs['invoiceModal'].hide();
            }
        },
        unselectAll() {
            this.itemsChecked = false;
            this.selectedItems = [];
        },
        watchSelectedItems(items) {
            if (this.selectedItems.length && items.length && this.selectedItems.length >= items.length) {
                let selected = [];
                this.selectedItems.forEach(item => {
                    selected.push(item.id)
                });
                let filteredItems = [];
                items.forEach(item => {
                    filteredItems.push(item.id)
                });
                selected = selected.sort(function(a, b) {
                    return a - b;
                });
                filteredItems = filteredItems.sort(function(a, b) {
                    return a - b;
                });
                if (JSON.stringify(selected) == JSON.stringify(filteredItems) || this.itemsInclude(selected, filteredItems)) {
                    this.itemsChecked = true;
                } else {
                    this.itemsChecked = false;
                }
            } else {
                this.itemsChecked = false;
            }
        },
        itemsInclude(selected, filtered) {
            let isIncluded = true;
            filtered.forEach(id => {
                if (!selected.includes(id)) {
                    isIncluded = false;
                }
            });
            return isIncluded;
        },
        filterItems() {
            let self = this;
            let items = this.tasks;
            if (items && items.length) {
                let filteredItems = items.filter(function (item) {
                    // washstation filter
                    if (item.washstation.id == self.filterWashStation || self.filterWashStation == 'all') {
                        // worker filter
                        if (item.worker.id == self.filterWorker || self.filterWorker == 'all') {
                            // customer filter
                            if (item.customer.id == self.filterCustomer || self.filterCustomer == 'all') {
                                // invoiced filter
                                //if (!item.invoice && self.filterOnlyUninvoiced || !self.filterOnlyUninvoiced) {
                                    // search filter
                                    if (self.filterSearch != '') {
                                        let customerName = item.customer ? item.customer.name : self.$t('task_new_customer');
                                        if (
                                            `${item.worker.firstname.toLowerCase()} ${item.worker.lastname.toLowerCase()}`.includes(self.filterSearch.toLowerCase()) || 
                                            `${item.worker.lastname.toLowerCase()} ${item.worker.firstname.toLowerCase()}`.includes(self.filterSearch.toLowerCase()) || 
                                            customerName.toLowerCase().includes(self.filterSearch.toLowerCase())
                                        ) {
                                            return item;
                                        }
                                    } else {
                                        return item;
                                    }
                                //}
                            }
                        }
                    }
                })
                this.watchSelectedItems(filteredItems);
                return filteredItems;
            }
        },
        washStationFilterOptions(washStations) {
			if (washStations && washStations.length) {
				let stations = [{
					val: "all",
					name: this.$t('task_label_filter_all'),
				}];
				washStations.forEach(washStation => {
                    stations.push({
                        val: washStation.id,
                        name: washStation.name,
                    });
				});
				return stations;
			}
        },
        workerFilterOptions(workers) {
			if (workers && workers.length) {
				let fWorkers = [{
                    val: "all",
                    label: this.$t('task_label_filter_all'),
                }];
				workers.forEach(worker => {
                    fWorkers.push({
                        val: worker.id,
                        label: `${worker.firstname} ${worker.lastname}`,
                    });
				});
				return fWorkers;
			}
        },
        customerFilterOptions(customers) {
			if (customers && customers.length) {
				let fCustomers = [
                    {
                        val: "all",
                        name: this.$t('task_label_filter_all'),
                    },
                    {
                        val: null,
                        name: this.$t('task_label_filter_customer_new'),
                    }
                ];
				customers.forEach(customer => {
                    if (customer.isActive) {
                        fCustomers.push({
                            val: customer.id,
                            name: customer.name,
                        });
                    }
				});
				return fCustomers;
			}
        },
        resetFilters() {
            this.filterSearch = '';
            this.filterWashStation = 'all';
            this.filterWorker = 'all';
            this.filterCustomer = 'all';
            this.filterOnlyUninvoiced = true;
        },
        showInvoiceModal() {
            this.$refs['invoiceModal'].show();
        },
        invoiceModalListItemVariant(item) {
            let condition_1 = !item.customer || item.customer === 0,
                condition_2 = item.invoice;
            if (condition_1 && condition_2) {
                return 'danger';
            } else if (condition_1) {
                return 'warning';
            } else if (condition_2) {
                return 'info';
            }  else {
                return null;
            }
        },
        warnInvoiceCustomer() {
            var showWarning = false;
            if (this.selectedItems && this.selectedItems.length) {
                this.selectedItems.forEach(item => {
                    if (!item.customer || item.customer === 0) {
                        showWarning = true;
                    }
                });
            }
            return showWarning;
        },
        warnInvoiceFilled() {
            var showWarning = false;
            if (this.selectedItems && this.selectedItems.length) {
                this.selectedItems.forEach(item => {
                    if (item.invoice) {
                        showWarning = true;
                    }
                });
            }
            return showWarning;
        },
        showTaskModal(task) {
            this.activeTask = task;
            this.$refs['showTaskModal'].show();
        },
        createInvoice() {
            var selectedIds = [];
            this.selectedItems.forEach(item => {
                if (item.customer && item.customer != 0 && !item.invoice) {
                    selectedIds.push(item.id);
                }
            });
            this.createInvoiceCall(selectedIds);
            this.unselectAll();
        },
    },
    watch: {
        selectedItems() {
            this.watchSelectedItems(this.filterItems());
        },
        filterOnlyUninvoiced(state) {
            this.getTasksConfirmed(state);
        },
    },
}
</script>
